/* ── iPull Theme JS ── */

// Hero video — freeze on last frame
const heroVideo = document.getElementById('heroVideo');
if (heroVideo) {
  heroVideo.addEventListener('ended', function() {
    this.pause();
  });
}

// FAQ Accordion
document.querySelectorAll('.faq-question').forEach(button => {
  button.addEventListener('click', () => {
    const item = button.closest('.faq-item');
    const wasOpen = item.classList.contains('active');
    document.querySelectorAll('.faq-item').forEach(faq => faq.classList.remove('active'));
    if (!wasOpen) item.classList.add('active');
  });
});

// Product image thumbnail switcher
const thumbs = document.querySelectorAll('.thumb');
const mainImg = document.getElementById('mainProductImage');
if (thumbs.length && mainImg) {
  thumbs.forEach(button => {
    button.addEventListener('click', () => {
      mainImg.src = button.dataset.img;
      thumbs.forEach(t => t.classList.remove('active'));
      button.classList.add('active');
    });
  });
}

// Contact form success state (for mailto fallback - not used with Shopify form)
const contactForm = document.getElementById('contactForm');
if (contactForm) {
  contactForm.addEventListener('submit', function(e) {
    e.preventDefault();
    const f = e.target;
    const subject = encodeURIComponent('iPull Inquiry from ' + (f.fname ? f.fname.value : '') + ' ' + (f.lname ? f.lname.value : ''));
    const body = encodeURIComponent(
      'Name: ' + (f.fname ? f.fname.value : '') + ' ' + (f.lname ? f.lname.value : '') +
      '\nEmail: ' + (f.email ? f.email.value : '') +
      '\nType: ' + (f.type ? f.type.value : '') +
      '\n\nMessage:\n' + (f.message ? f.message.value : '')
    );
    window.location.href = 'mailto:info@ipull.co?subject=' + subject + '&body=' + body;
    setTimeout(() => {
      f.style.display = 'none';
      const success = document.getElementById('form-success');
      if (success) success.style.display = 'block';
    }, 600);
  });
}
